import { render, staticRenderFns } from "./SpecsWithSubSpecs.vue?vue&type=template&id=b9792be2&scoped=true"
import script from "./SpecsWithSubSpecs.vue?vue&type=script&lang=js"
export * from "./SpecsWithSubSpecs.vue?vue&type=script&lang=js"
import style0 from "./SpecsWithSubSpecs.vue?vue&type=style&index=0&id=b9792be2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9792be2",
  null
  
)

export default component.exports